import { computed } from 'vue';

import { useMediaQuery } from '@vueuse/core';

// Viewport-independent device signal: unlike innerWidth, `pointer: coarse` doesn't change
// when the viewport meta switches to width=1280 (desktop mode), so touch-only UI stays visible.
// Reactive (not a one-time read) so DevTools touch emulation is picked up without a reload;
// maxTouchPoints covers emulators/devices where the media query lags the touch flag.
export function useIsTouchDevice() {
  const isCoarsePointer = useMediaQuery('(pointer: coarse)');
  const isTouchDevice = computed(() => isCoarsePointer.value || navigator.maxTouchPoints > 0);

  return { isTouchDevice };
}
